import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/AnalyticsService';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const pageName = location.pathname.replace('/', '') || 'home';
    analyticsService.logPageView(pageName);
    analyticsService.logScreenView(pageName);
  }, [location]);
};

export default usePageTracking;
